type CredentialDocument = {
  filestackDocument?: unknown
  filestackDocumentName?: unknown
}

export const isPdfCredential = ({ filestackDocumentName, filestackDocument }: CredentialDocument) => {
  let documentReference = ""
  if (typeof filestackDocumentName === "string") documentReference = filestackDocumentName
  else if (typeof filestackDocument === "string") documentReference = filestackDocument

  return documentReference.toLowerCase().split("?")[0]?.endsWith(".pdf") ?? false
}
